import { useReducer } from "react";
import { startOfYear } from "date-fns";
import { TimeScope } from "generated/graphql";
import { Topic, TopicGroup, topicsByGroup } from "Constants";

export type ChartOptions = {
  topic: Topic;
  timeScope: TimeScope;
  timeStart: Date;
  minimized: boolean;
};

type State = {
  charts: ChartOptions[];
};

export enum ActionType {
  AddChart,
  DuplicateChart,
  UpdateChart,
  RemoveChart
}

type Action =
  | {
      type: ActionType.AddChart;
      payload: { options: ChartOptions };
    }
  | {
      type: ActionType.DuplicateChart;
      payload: { index: number };
    }
  | {
      type: ActionType.UpdateChart;
      payload: { index: number; options: Partial<ChartOptions> };
    }
  | {
      type: ActionType.RemoveChart;
      payload: { index: number };
    };

const reducer = (state: State, action: Action): State => {
  const charts: ChartOptions[] = [...state.charts];

  switch (action.type) {
    case ActionType.AddChart: {
      const { options } = action.payload;
      charts.push({ ...options });
      break;
    }
    case ActionType.DuplicateChart: {
      const { index } = action.payload;
      charts.splice(index, 0, { ...charts[index] });
      break;
    }
    case ActionType.RemoveChart: {
      const { index } = action.payload;
      charts.splice(index, 1);
      break;
    }
    case ActionType.UpdateChart: {
      const { index, options } = action.payload;
      charts[index] = { ...charts[index], ...options };
      break;
    }
  }

  return { charts };
};

export const useAnalysisChartsReducer = (topicGroup: TopicGroup) => {
  const initialState: State = {
    charts: [
      {
        topic: topicsByGroup[topicGroup][0],
        timeScope: TimeScope.Year,
        timeStart: startOfYear(new Date()),
        minimized: false
      }
    ]
  };

  return useReducer(reducer, initialState);
};
